
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear  placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="赛季赛区">
              <a-cascader :show-search="{ sjsqFilter }" @change="onSjsqChange" :options="sjsqOptions" :fieldNames="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择赛区" v-model="queryParam.sjsq" changeOnSelect />
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="省市">
                <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="queryParam.namekeys" changeOnSelect
                />
              </a-form-item>
            </a-col> 

          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" >
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator" >

      <div v-if="selectedRowKeys.length > 0">
      队伍预订&nbsp;
      
      <a-select @change="onRoomTypeChange" style="width:300px" v-model="setAll.room_type_id" placeholder="选择队伍预订房型"
                allowClear>
        <a-select-option :key="index" :value="item.id" v-for="(item,index) in room_type_options">{{item.name}}</a-select-option> 
      </a-select>
      <span>共{{setAll.room_type_count}}间</span>

      &nbsp;安排到&nbsp;

      <a-select @change="onHotelChange" style="width:300px" v-model="setAll.room_id" placeholder="选择酒店房型"
                allowClear>
        <a-select-option :key="index" :value="item.room_id" v-for="(item,index) in hotel_room_options">{{item.hotel_name}} - {{item.room_name}}</a-select-option> 
      </a-select>&nbsp;
      <span>剩余{{setAll.room_count}}间</span>&nbsp;

      <a-button type="primary" @click="onSetAll">批量设置</a-button></div>
    <!--  <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item v-for="(hotel,hindex) in hotelOptions" @click="setHotel(hotel.id)" :key="hindex">{{hotel.name}}</a-menu-item>
          <a-menu-item v-show="hotelOptions.length==0" disabled >请先选择赛区或者当前赛区未配置酒店信息</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          设置酒店 <a-icon type="setting" />
        </a-button>
      </a-dropdown>

      <a-button v-if="selectedRowKeys.length > 0" @click="unSetHotel()" style="margin-left: 8px"  >
        取消酒店 <a-icon type="setting" />
      </a-button>-->

<!--      <a-button @click="download(1)" style="margin-left: 8px"  >-->
<!--        酒店交通安排表(导出) <a-icon type="download" />-->
<!--      </a-button>-->


    </div>

    <s-table
            ref="table"
            size="default"
            :columns="columns"
            :data="loadData"
            :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="danwei" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{record.danwei}}<br/>
            {{record.saiqu_name}}
            <br/><span style="color: #999">{{record.mingcheng}}</span>
            <br/>
            {{record.create_time|timeFormat}}
            <br/>
          </div>
      </span>
      <span slot="status" slot-scope="text,record">
        <p :key="rkey" v-for="(room,rkey) in record.room_type" :class="room.count>0?'highlight':''">
          {{room.name}} x {{room.count}}
        </p> 
      </span>
      <span slot="action" slot-scope="text,record">
        <div v-if="!record.edit">

        
        <p :key="rkey" v-for="(room,rkey) in record.hotel_room_list" :class="room.count>0?'highlight':''">
          {{room.hotel_name}}-{{room.room_name}} x {{room.count}}间
        </p> 
        <p>
        <a   @click="onEdit(record)"><a-icon
              type="edit"
              class="editable-cell-icon" 
              
      />编辑</a>
      </p>

        </div>
        <div v-else>
        
        <p :key="rkey" v-for="(room,rkey) in record.hotel_room_list">
          {{room.hotel_name}}-{{room.room_name}} <br/>(库存{{room_stock_hash['room_id_'+room.room_id].stock}}间，已入住{{room_stock_hash['room_id_'+room.room_id].used}}间，剩余{{room_stock_hash['room_id_'+room.room_id].last}}间)
          <!-- {{room_stock_hash['room_id_'+room.id].stock}} -->
          <br/>
          <a-input-number style="width:100px" type="number" v-model="room.count" :max="room_stock_hash['room_id_'+room.room_id].last" />
          
        </p> 
        <p>
        <a  
              @click="editSave(record)" ><a-icon
              type="check"
              class="editable-cell-icon" 
      />保存</a> 
          <a-divider type="vertical"/>
        <a  
              @click="editCancel(record)" >取消</a>
      </p>

        </div>
      </span>
    </s-table>




  </a-card>
</template>

<style lang="less" scoped>
/deep/.editable-cell{ display: inline !important;}
/deep/.editable-cell-input-wrapper{ display: inline !important;} 
/deep/.editable-cell-text-wrapper{ display: inline !important;} 

.highlight{color: rgb(182, 58, 9); font-weight: bold;}
</style>

<script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import PicUploader from '@/components/PicUploader/'
  import FileUploader from '@/components/FileUploader/'
  import JiaolianPicker from '@/components/JiaolianPicker/'
  import CaipanPicker from '@/components/CaipanPicker/'
  import areaOptions from '@/utils/area'
  import moment from 'moment'
  import setting from '@/config/setting'
  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');

  import { getShisuApplyList ,editShisuRoomCount,sjsqOptions,hotelOptions,setHotel,unSetHotel,editShisuAll} from '@/api/sai'
  export default {
    name: 'KaojiApplyList',
    components: {
      AInput,
      ATextarea,
      FileUploader,
      PicUploader,
      STable,
      EditableCell,
      CaipanPicker,
      JiaolianPicker,
    },
    data () {
      return {
        areaOptions,
        visible: false,
        orderVisible: false,
        saveLoading:false,
        jiaolianPickerShow:false,
        caipanPickerShow:false,
        sjsqOptions:[],
        hotelOptions:[],
        edit_list:[],
        setAll:{

        },
        room_stock_hash:{

        },
        orderFormData:{

        },
        formData:{
          id:0,
          danwei:'',
          mingcheng:'',
          datetitle_moment:null,
          datetitle:'',
          heying:[],
          jiaolian:[],
          caipan:[],
          subjectlist:[],
          loglist:[],
        },
        time_range_moment:[],
        time_range:[],
        labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          keywords:'',
          sjsq:[]
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '报名信息',
            dataIndex: 'danwei',
            scopedSlots: { customRender: 'danwei' },
          },
                
          {
            title: '食宿预订',
            dataIndex: 'status',
            width: '250px',
            scopedSlots: { customRender: 'status' },
          },
                
          {
            title: '酒店编排',
            dataIndex: 'action',
            fixed: 'right',
            width: '400px',
            scopedSlots: { customRender: 'action' },
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          let that= this;

          if (this.time_range_moment[0] && this.time_range_moment[1]) {
            this.queryParam.time_range = [
              this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
              this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
            ]
          } else {
            this.queryParam.time_range = []
          }

          this.queryParam = Object.assign(this.queryParam,parameter);
          return getShisuApplyList(this.queryParam)
                  .then(res => {
                    console.log('res',res);
                    res.data.list = res.data.list.map(item => {
                      item.edit=false
                      return item;
                    });
                    this.room_stock_hash = res.data.room_stock_hash
                    if(res.data.list.length>0 && this.queryParam.sjsq.length==2){
                      this.room_type_options = res.data.list[0].room_type 
                      this.hotel_room_options = res.data.list[0].hotel_room_list
                    }
                    this.onRoomTypeChange()
                    return res.data
                  })
        },

        selectedRowKeys: [],
        selectedRows: [],
        room_type_options:[],
        hotel_room_options:[],
        cashFormData:{
          ids:[],
          to_type:'',
          price:0,
          note:'',
          count:0,
        }
      }
    },
    computed:{
    },
    created(){
    },

    mounted(){
      let that = this;
      that.getSjsqOptions();
    },
    methods: {
      moment,
      getSjsqOptions(){
        let that = this;
        sjsqOptions({}).then(res =>{
          that.sjsqOptions = res.data;
        });
      },

      download(type){
        console.log('this.queryParam')
        console.log(this.queryParam)
        if(typeof this.queryParam.sjsq == 'undefined' || this.queryParam.sjsq.length !=2){
          this.$message.error('请先选择赛区');
          return ;
        }
        switch (type){
          case 1:
            window.open(setting.apiBaseURL+'/wyhadminapi/sai/bussettableout?saiqu='+this.queryParam.sjsq[1]);
            break;

        }
      },

      editSave(record) { 
        let self = this;
        editShisuRoomCount({
          id:record.id,
          list:record.hotel_room_list
        }).then(res => {
          self.$refs.table.refresh(false)
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },
      onEdit(record){
        let that = this;
        if(this.edit_list.filter(item =>{
          item.id == record.id
        }).length ==0){
          this.edit_list.push(record)
        }
        this.edit_list.map(item =>{
          that.editCancel(item)
        })
        record.edit = true;
      },
      editCancel(record){
        record.hotel_room_list = record.hotel_room_list.map(item =>{
          item.count = item.ocount 
          return item
        })
        record.edit = false;
      },

      onSjsqChange(value){
        let that = this;
        if(value.length ==2){
          console.log(value);
          that.getHotelOptions(value[1]);
        }
      },
      getHotelOptions(saiqu){
        let that = this;
        console.log(saiqu);
        hotelOptions({
          saiqu:saiqu
        }).then(res =>{
          that.hotelOptions = res.data;
        });
      },
      setHotel(hotel_id){
        let that = this;
        setHotel({
          hotel_id:hotel_id,
          ids:that.selectedRowKeys,
        }).then(res =>{
          that.$message.success('设置成功')
          that.$refs.table.refresh()
        });
      },
      unSetHotel(hotel_id){
        let that = this;
        unSetHotel({
          ids:that.selectedRowKeys,
        }).then(res =>{
          that.$message.success('取消成功')
          that.$refs.table.refresh()
        });
      },
      //展开关闭
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
      onRoomTypeChange(){
        let that = this; 
        that.setAll.room_type_count = 0;
        if(this.setAll.room_type_id){
          this.selectedRows.map(item =>{
            that.setAll.room_type_count+= item.room_type.filter(ritem =>{
              return ritem.id == that.setAll.room_type_id
            })[0].count
          })
        }

      },
      onHotelChange(){
        let that = this; 
        if(this.setAll.room_id){
         that.setAll.room_count = this.room_stock_hash['room_id_'+that.setAll.room_id].last; 
        }else{
          that.setAll.room_count= 0;
        }
      },
      onSetAll(){
        let that = this;
        let list = [];
        if(!this.setAll.room_id){
          that.$message.error('请选择酒店房型');
          return ;
        }
        if(!this.setAll.room_type_id){
          that.$message.error('请选择队伍预订房型');
          return ;
        }
        if(this.setAll.room_type_count>this.setAll.room_count){
          that.$message.error('酒店房间数不足，请少勾选一些队伍');
          return ;
        }
        this.selectedRows.map(item =>{
          let count = item.room_type.filter(ritem =>{
            return ritem.id == that.setAll.room_type_id
          })[0].count

          let hotel_id = that.hotel_room_options.filter(hitem =>{
            return hitem.room_id == that.setAll.room_id
          })[0].hotel_id
          list.push({
            baoming_id:item.id,
            count:count,
            hotel_id:hotel_id,
            room_id:that.setAll.room_id
          })
        })
        console.log(list);
        // return ;
        editShisuAll({ 
          list
        }).then(res =>{ 
          that.$message.success('设置成功');
          that.setAll = {}
          that.$refs.table.refresh(false)
        });

      },
      // 查
      onSearch() {
        let self = this;
        self.$refs.table.refresh(false)
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
        this.onRoomTypeChange()
      },
      sjsqFilter(inputValue, path) {
        return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
      },

    },
    filters:{
    },
    watch: {
    }
  }
</script>
